import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const OrderForm: React.FC = () => {
  const navigate = useNavigate();
  const { schoolId, occasion } = useParams();

  const [formData, setFormData] = useState({
    recipientName: '',
    email: '',
    customMessage: '',
    deliveryDate: '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Store order data in localStorage for the payment page
    const orderData = {
      schoolId,
      occasion,
      ...formData,
      price: 50, // Default price, could be dynamic based on school/occasion
      timestamp: new Date().toISOString()
    };
    
    localStorage.setItem('orderData', JSON.stringify(orderData));
    navigate('/payment');
  };

  return (
    <div className="min-h-screen bg-midnight py-12">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-white mb-4">Complete Your Order</h1>
          <p className="text-lg text-gray-300">Provide the details for your personalized video</p>
        </div>
        
        <div className="card">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label className="form-label">Recipient Name</label>
              <input
                type="text"
                name="recipientName"
                value={formData.recipientName}
                onChange={handleInputChange}
                className="input"
                placeholder="Enter the name of the person receiving the video"
                required
              />
            </div>
            
            <div>
              <label className="form-label">Your Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="input"
                placeholder="Enter your email address"
                required
              />
            </div>
            
            <div>
              <label className="form-label">Custom Message</label>
              <textarea
                name="customMessage"
                value={formData.customMessage}
                onChange={handleInputChange}
                className="input"
                rows={4}
                placeholder="Add a personal message for the band to include in the video..."
                required
              />
            </div>
            
            <div>
              <label className="form-label">Delivery Date (Optional)</label>
              <input
                type="date"
                name="deliveryDate"
                value={formData.deliveryDate}
                onChange={handleInputChange}
                className="input"
              />
            </div>
            
            <button
              type="submit"
              className="btn-primary w-full"
            >
              Continue to Payment
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OrderForm; 